(() => {
  const init = async (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const variant = root.querySelector('[data-variant]');
    const currency = root.dataset.currency || 'CHF';
    const locale = root.dataset.locale === 'de' ? 'de-CH' : 'en-CH';
    const formatter = new Intl.NumberFormat(locale, { style: 'currency', currency, maximumFractionDigits: 0 });
    const form = root.querySelector('form');
    [...variant.options].forEach((option) => { option.textContent = `${option.dataset.label} · ${formatter.format(Number(option.dataset.variantPrice) / 100)}`; });
    root.querySelectorAll('[data-base-price]').forEach((el) => { el.textContent = formatter.format(Number(el.dataset.basePrice) / 100); });
    let equipment;
    const update = () => {
      const option = variant.selectedOptions[0];
      const selected = equipment.calculate(false);
      const total = Number(option.dataset.variantPrice) + selected.delta;
      const price = `${formatter.format(total / 100)}${selected.unknown ? ' + ' + equipment.labels.onRequest : ''}`;
      root.querySelectorAll('[data-price]').forEach((el) => { el.textContent = price; });
      const summary = [option.dataset.label, ...selected.lines, price, equipment.labels.estimate].join('\n');
      root.querySelector('[data-summary]').textContent = summary;
      root.querySelector('[data-build-input]').value = summary;
      root.querySelector('[data-variant-input]').value = option.value;
      root.querySelector('[data-review]').hidden = true;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    };
    equipment = await window.HilitePilotEquipment(root, update);
    if (!root.isConnected) return;
    variant.addEventListener('change', update);
    root.querySelectorAll('[data-choose]').forEach((button) => button.addEventListener('click', () => {
      variant.value = button.dataset.choose;
      update();
      variant.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      variant.focus({ preventScroll: true });
    }));
    form.addEventListener('submit', (event) => {
      if (root.dataset.liveRequests !== 'true') {
        event.preventDefault();
        root.querySelector('[data-review]').hidden = false;
      }
    });
    root.querySelector('[data-form-button]').disabled = false;
    const hero = root.querySelector('[data-hero-cta]');
    const contact = root.querySelector('.tp-contact');
    const sticky = root.querySelector('[data-sticky]');
    let heroPast = false;
    let contactVisible = false;
    const showSticky = () => { sticky.hidden = !(heroPast && !contactVisible); };
    const heroObserver = new IntersectionObserver(([entry]) => {
      heroPast = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      showSticky();
    });
    const contactObserver = new IntersectionObserver(([entry]) => { contactVisible = entry.isIntersecting; showSticky(); });
    heroObserver.observe(hero);
    contactObserver.observe(contact);
    root.addEventListener('focusin', (event) => {
      if (!sticky.hidden && !sticky.contains(event.target)) event.target.scrollIntoView({ block: 'nearest' });
    });
    update();
  };
  document.querySelectorAll('[data-titan-pilot]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-titan-pilot]').forEach(init));
})();
